import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( window.innerWidth > 768 ) {
        const $ = jQuery;

        // Recompute these on every ScrollTrigger.refresh()
        const getTopOffset = () => {
          let top = $( 'header' ).height() + 180;
          if ( $( 'body.logged-in' ).length > 0 ) top += 32; // WP admin bar
          return top;
        };

        $( '.sticky-jump-links__content' ).each( function() {
          const jumpLink = '#jump-link-' + $( this ).attr( 'id' );

          gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              // Functional start/end so they recalc after your global refresh runs
              start: () => `top top+=${getTopOffset()}`,
              end: () => `bottom top+=${getTopOffset()}`,
              invalidateOnRefresh: true,

              onEnter: () => $( jumpLink ).addClass( 'active' ),
              onLeave: () => $( jumpLink ).removeClass( 'active' ),
              onEnterBack: () => $( jumpLink ).addClass( 'active' ),
              onLeaveBack: () => $( jumpLink ).removeClass( 'active' ),
            },
          } );
        } );

        // Optional: a first pass after images/fonts settle
        window.addEventListener( 'load', () => ScrollTrigger.refresh() );
      }

      function handleLargeChange( event ) {
        const $ = jQuery;
        const $content = $( '.sticky-jump-links-content' );

        if ( event.matches && !$content.hasClass( 'is-open' ) ) {
          $content.attr( 'aria-hidden', true );
        } else if ( !event.matches && !$content.hasClass( 'is-open' ) ) {
          $content.attr( 'aria-hidden', false );
        } else if ( !event.matches && $( '.sticky-jump-links__toggle' ).hasClass( 'is-open' ) ) {
          $( '.sticky-jump-links__toggle' ).trigger( 'click' );
          $content.attr( 'aria-hidden', false );
          console.log( 'clicking' );
        }

        // When layout mode changes, nudge ScrollTrigger to recalc.
        // (Your global Smash Balloon bridge will also refresh when feeds change height.)
        ScrollTrigger.refresh();
      }

      // Breakpoint watcher for your layout mode
      const mobileSize = window.matchMedia( '(max-width: 1024px)' );
      mobileSize.addEventListener( 'change', handleLargeChange );
    },
    finalize: function() {},
  };

  app.registerComponent( 'sticky-jump-links', COMPONENT );
} )( app );
